import information from '@/views/mainContentScore/information'
import special from '@/views/mainContentScore/information/special'
import cut from '@/views/mainContentScore/information/cut'
import synthesize from '@/views/mainContentScore/information/synthesize'
import enclosure from '@/views/mainContentScore/information/enclosure'
import download from '@/views/mainContentScore/information/download'
import addmuseumperson from '@/views/mainContentScore/user/listNew'
import specialist from '@/views/mainContentScore/specialist'
import addspecialist from '@/views/mainContentScore/specialist/listNew'
import country from '@/views/mainContentScore/country'
import addcountry from '@/views/mainContentScore/country/listNew'
import province from '@/views/mainContentScore/province'
import addprovince from '@/views/mainContentScore/province/listNew'
import pftj from '@/views/mainContentScore/pftj'
import otherfile from '@/views/mainContentScore/information/otherfile'
import basemenu from '@/views/mainContent/information/base'
import gaishu from '../views/mainContent/information/gaishu'
import xiangmu from '../views/mainContent/information/xiangmu'
import gaikuang from '../views/mainContent/information/gaikuang'
import score from '@/views/mainContent/information/score'


export default {
  path: '/informationDeclarationScore',
  component: information,
  exact: true,
  children: [
    { //基本信息
      path: '/informationDeclaration/museumbaseinfo/baseScore',
      component: basemenu,
      exact: true,
    },
    { //博物馆活动项目
      path: '/informationDeclaration/museumbaseinfo/activityScore',
      component: xiangmu,
      exact: true,
    },
    { //发展概况
      path: '/informationDeclaration/museumbaseinfo/developScore',
      component: gaikuang,
      exact: true,
    },
    { //发展概况
      path: '/informationDeclaration/museumbaseinfo/resourceScore',
      component: gaishu,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/specialScore',
      component: special,
      exact: true,
    },
    {
      path: '/informationDeclaration/enclosureScore',
      component: enclosure,
      exact: true,
    },
    {
      path: '/informationDeclaration/downloadScore',
      component: download,
      exact: true,
    },
    {
      path: '/informationDeclaration/addmuseumperson',
      component: addmuseumperson,
      exact: true,
    },
    {
      path: '/informationDeclaration/specialist',
      component: specialist,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/warningScore',
      component: cut,
      exact: true,
    },
    {
      path: '/informationDeclaration/proposalScore',
      component: synthesize,
      exact: true,
    },
    {
      path: '/informationDeclaration/addspecialist',
      component: addspecialist,
      exact: true,
    },
    {
      path: '/informationDeclaration/country',
      component: country,
      exact: true,
    },
    {
      path: '/informationDeclaration/addcountry',
      component: addcountry,
      exact: true,
    },
    {
      path: '/informationDeclaration/province',
      component: province,
      exact: true,
    },
    {
      path: '/informationDeclaration/addprovince',
      component: addprovince,
      exact: true,
    },
    {
      path: '/informationDeclaration/pftj',
      component: pftj,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/otherfileScore',
      component: otherfile,
      exact: true,
    },
    {
      path: '/informationDeclaration/scoredetailScore',
      component: score,
      exact: true,
    },
  ]
}
